import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { ApplicationState } from '@mews-commander/types';
import { DescriptionItem } from '@mews-commander/ui';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { Reservation } from '@mews-commander/data-access';
import { getResourceCategoryIdByResourceId } from '@mews-commander/legacy-entities/src/ducks/resourceCategoryAssignments';
import { getResourceCategoryNameByResourceId } from '../../selectors/reservationModuleState/reservationSelection';

interface OwnProps {
    requestedCategoryId: Reservation['requestedCategoryId'];
    assignedResourceId: Reservation['assignedResourceId'];
    serviceId: Reservation['serviceId'];
}
interface StateProps {
    assignedCategoryName: string | undefined;
    assignedCategoryId: string | undefined;
}
type Props = OwnProps & StateProps;

const AssignedResourceCategory = ({ requestedCategoryId, assignedCategoryId, assignedCategoryName }: Props) => {
    if (assignedCategoryId && assignedCategoryId !== requestedCategoryId) {
        return (
            <DescriptionItem
                data-test-id="assignedResourceCategory"
                term={<LocalizedText textKey={TextKey.AssignedResourceCategory} />}
                definition={assignedCategoryName}
            />
        );
    }
    return null;
};

export default connect<StateProps, {}, OwnProps, ApplicationState>(
    createStructuredSelector({
        assignedCategoryName: (state: ApplicationState, { assignedResourceId, serviceId }: OwnProps) =>
            assignedResourceId
                ? getResourceCategoryNameByResourceId(state, { resourceId: assignedResourceId, serviceId })
                : undefined,
        assignedCategoryId: (state: ApplicationState, { assignedResourceId, serviceId }: OwnProps) =>
            assignedResourceId
                ? getResourceCategoryIdByResourceId(state, { resourceId: assignedResourceId, serviceId })
                : undefined,
    })
)(AssignedResourceCategory);
